(function ($) {
  $(function () {
    // Typewriter.
    var i = 0;
    var i2 = 0;
    var i3 = 0;
    var i4 = 0;
    var i5 = 0;
    var i6 = 0;
    var i7 = 0;
    var speed = 25;
    var line1 = "on time, on budget";
    var line2 = "your net zero targets";
    var line3 = "specialist expertise";
    var line4 = "beyond expectations";
    var line5 = "added value";
    var line6 = "a partnerships first approach";
    var line7 = "straightforward solutions";

    function typeWriter() {
      clearTimeout();

      if (i < line1.length) {
        document.getElementById("intro").innerHTML += line1.charAt(i);
        i++;
        setTimeout(typeWriter, speed);
      }

      if (i == line1.length) {
        clearTimeout();

        setTimeout(() => {
          document.getElementById("intro").innerHTML = "";

          clearTimeout();

          setTimeout(() => {
            typeWriter2();
          }, 1000);
        }, 1000);
      }
    }

    function typeWriter2() {
      clearTimeout();

      if (i2 < line2.length) {
        document.getElementById("intro").innerHTML += line2.charAt(i2);
        i2++;
        setTimeout(typeWriter2, speed);
      }

      if (i2 == line2.length) {
        clearTimeout();

        setTimeout(() => {
          document.getElementById("intro").innerHTML = "";

          clearTimeout();

          setTimeout(() => {
            typeWriter3();
          }, 1000);
        }, 1000);
      }
    }

    function typeWriter3() {
      if (i3 < line3.length) {
        document.getElementById("intro").innerHTML += line3.charAt(i3);
        i3++;
        setTimeout(typeWriter3, speed);
      }

      if (i3 == line3.length) {
        clearTimeout();

        setTimeout(() => {
          document.getElementById("intro").innerHTML = "";

          clearTimeout();

          setTimeout(() => {
            typeWriter4();
          }, 1000);
        }, 1000);
      }
    }

    function typeWriter4() {
      if (i4 < line4.length) {
        document.getElementById("intro").innerHTML += line4.charAt(i4);
        i4++;
        setTimeout(typeWriter4, speed);
      }

      if (i4 == line4.length) {
        clearTimeout();

        setTimeout(() => {
          document.getElementById("intro").innerHTML = "";

          clearTimeout();

          setTimeout(() => {
            typeWriter5();
          }, 1000);
        }, 1000);
      }
    }

    function typeWriter5() {
      if (i5 < line5.length) {
        document.getElementById("intro").innerHTML += line5.charAt(i5);
        i5++;
        setTimeout(typeWriter5, speed);
      }

      if (i5 == line5.length) {
        clearTimeout();

        setTimeout(() => {
          document.getElementById("intro").innerHTML = "";

          clearTimeout();

          setTimeout(() => {
            typeWriter6();
          }, 1000);
        }, 1000);
      }
    }

    function typeWriter6() {
      if (i6 < line6.length) {
        document.getElementById("intro").innerHTML += line6.charAt(i6);
        i6++;
        setTimeout(typeWriter6, speed);
      }

      if (i6 == line6.length) {
        clearTimeout();

        setTimeout(() => {
          document.getElementById("intro").innerHTML = "";

          clearTimeout();

          i7 = 0;

          setTimeout(() => {
            typeWriter7();
          }, 1000);
        }, 1000);
      }
    }

    function typeWriter7() {
      if (i7 < line7.length) {
        document.getElementById("intro").innerHTML += line7.charAt(i7);
        i7++;
        setTimeout(typeWriter7, speed);
      }

      if (i7 == line7.length) {
        clearTimeout();

        setTimeout(() => {
          document.getElementById("intro").innerHTML = "";

          clearTimeout();

          i = 0;
          i2 = 0;
          i3 = 0;
          i4 = 0;
          i5 = 0;
          i6 = 0;

          setTimeout(() => {
            typeWriter();
          }, 1000);
        }, 1000);
      }
    }

    if ($("#intro").length > 0) {
      typeWriter();
    }

    // Blinking cursor.
    var cursor = true;
    var cursorSpeed = 250;

    if ($("#intro").length > 0) {
      setInterval(() => {
        if (cursor) {
          document.getElementById("cursor").style.opacity = 0;
          cursor = false;
        } else {
          document.getElementById("cursor").style.opacity = 1;
          cursor = true;
        }
      }, cursorSpeed);
    }
  });
})(jQuery);
